import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.17 1.165a.75.75 0 0 0-1.34.67l.837 1.675a6 6 0 0 0-2.568 3.9L5.99 8h12.02l-.109-.59a6 6 0 0 0-2.568-3.9l.838-1.675a.75.75 0 0 0-1.342-.67l-.837 1.674A6 6 0 0 0 12 2.5a6 6 0 0 0-1.992.339zM3.5 9A1.5 1.5 0 0 0 2 10.5v5a1.5 1.5 0 0 0 3 0v-5A1.5 1.5 0 0 0 3.5 9m17 0a1.5 1.5 0 0 0-1.5 1.5v5a1.5 1.5 0 0 0 3 0v-5A1.5 1.5 0 0 0 20.5 9M18 9H6v8.5A1.5 1.5 0 0 0 7.5 19H8v2.5a1.5 1.5 0 0 0 3 0V19h2v2.5a1.5 1.5 0 0 0 3 0V19h.5a1.5 1.5 0 0 0 1.5-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandPlatformAndroid = { render };
export {
  brandPlatformAndroid as default,
  render
};
//# sourceMappingURL=brand-platform-android.svg.js.map
